<template>
  <div class="flex w-full items-center justify-between text-center text-main dark-theme">
    <img data-testid="sidebar-logo" class="m-2" src="/assets/images/manager_logo.svg" />
    <DropDown wrapper-class="border-main-solid! bg-transparent! rounded-sm">
      <template #activator="{ open, isOpen }">
        <button
          data-testid="sidebar-language-toggle"
          class="state-layer-neutral rounded-sm p-2"
          :class="{ 'bg-state-hover-neutral': isOpen }"
          @click.stop="open"
        >
          <MdiSvg :path="mdiWeb" :size="20" />
        </button>
      </template>
      <template #default>
        <div class="h-full bg-surface text-left dark-theme">
          <p class="w-40 px-4 py-2 text-body-s-bold text-subtle">{{ t('SideBar.selectLanguage') }}</p>
          <button
            v-for="lang in availableLocales"
            :key="lang.value"
            :data-testid="'sidebar-language-option-' + lang.value"
            class="state-layer-neutral flex w-full justify-between px-4 py-3"
            :class="{ 'bg-state-hover-neutral text-selected': lang.value == localeStore.locale }"
            @click="() => localeStore.setLocale(lang.value)"
          >
            <div>
              <flag :iso="lang.flag" class="mr-1 h-4! w-4! rounded-full border border-main-solid" />
              {{ lang.text }}
            </div>
            <MdiSvg v-if="lang.value == localeStore.locale" :path="mdiCheck" :size="20" />
          </button>
        </div>
      </template>
    </DropDown>
  </div>
</template>
<script setup lang="ts">
import { mdiCheck, mdiWeb } from '@mdi/js'
import { DropDown, MdiSvg } from '@ramp106/omrjs-core-ui'
import { useI18n } from 'vue-i18n'

import { useLocaleStore } from '@/stores'

defineProps<{
  availableLocales: Array<{ text: string; value: string; flag: string }>
}>()

const localeStore = useLocaleStore()
const { t } = useI18n()
</script>
